import React, { useState, useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import './Navbar.css'

const navLinks = [
  { to: '/',          label: 'Home'      },
  { to: '/about',     label: 'About'     },
  { to: '/services',  label: 'Services'  },
  { to: '/platforms', label: 'Platforms' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner container">
        {/* Logo */}
        <Link to="/" className="navbar__logo" onClick={() => setMenuOpen(false)}>
          <span className="navbar__logo-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <polygon points="16,2 30,10 30,22 16,30 2,22 2,10" fill="none" stroke="#00c8ff" strokeWidth="2"/>
              <circle cx="16" cy="16" r="5" fill="#00c8ff"/>
              <line x1="16" y1="7" x2="16" y2="11" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="16" y1="21" x2="16" y2="25" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="7.3" y1="11.5" x2="10.7" y2="13.5" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="21.3" y1="18.5" x2="24.7" y2="20.5" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="7.3" y1="20.5" x2="10.7" y2="18.5" stroke="#00c8ff" strokeWidth="1.5"/>
              <line x1="21.3" y1="13.5" x2="24.7" y2="11.5" stroke="#00c8ff" strokeWidth="1.5"/>
            </svg>
          </span>
          <span className="navbar__logo-text">
            GT <span className="navbar__logo-accent">Expression</span>
          </span>
        </Link>

        {/* Desktop links */}
        <ul className="navbar__links">
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  `navbar__link ${isActive ? 'navbar__link--active' : ''}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <Link to="/services" className="btn btn--primary navbar__cta">
          Get Started
        </Link>

        {/* Hamburger */}
        <button
          className={`navbar__hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="navbar__drawer">
          {navLinks.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `navbar__drawer-link ${isActive ? 'navbar__drawer-link--active' : ''}`
              }
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </NavLink>
          ))}
          <Link
            to="/services"
            className="btn btn--primary"
            style={{ marginTop: '12px' }}
            onClick={() => setMenuOpen(false)}
          >
            Get Started
          </Link>
        </div>
      )}
    </nav>
  )
}
